// Pharmascience — "Recommended Review" reveal on the quiz FAIL result screen.
//
// Consumer of the `.bnrmp-reviewrow` rows emitted (hidden) by
// learndash/ld30/quiz/partials/show_quiz_result_box.php.
//
// ── WHY THIS RUNS IN THE BROWSER AT ALL ─────────────────────────────────────
// Which questions a learner got wrong is known ONLY client-side. WPProQuiz
// scores in JS (`wpProQuiz_front.js` `checkAnswer`), and this quiz has answer-
// response display OFF, so LearnDash emits no `.wpProQuiz_response` block for
// PHP or CSS to read either (measured 2026-08-19: no `.wpProQuiz_listItem` has
// such a child). PHP therefore emits every row that HAS authored remediation
// feedback and this module reveals the subset that applies.
//
// ── THE SEAM: LearnDash's own public event ──────────────────────────────────
// `wpProQuiz_front.js:444` triggers `questionSolvedIncorrect` on
// `.wpProQuiz_content` with `values.index` — the question's DOM index. LD's own
// question-overview panel consumes the same event, so it is a supported public
// contract, not an internal detail.
//
// Measured 2026-08-19 on quiz 469: deliberately failing questions 1, 2 and 5
// reported exactly `[0, 1, 4]`, matching question ids 24, 20, 23 — which are
// precisely the three carrying authored feedback.
//
// 🔴 PRESENTATION ONLY. This module listens; it never scores, never re-emits
// LearnDash markup, and never alters the pass/fail verdict. If the event never
// fires, every row simply stays hidden and the region stays hidden with it —
// the failure mode is "no recommendations", never a wrong one.
//
// Rows whose question has no authored feedback are absent server-side (F-77 is
// the content gap), so nothing here can invent a remediation target.

export function initQuizResultReview() {
	const region = document.querySelector( '[data-bnrmp-review]' );

	if ( ! region ) {
		return;
	}

	const content = document.querySelector( '.wpProQuiz_content' );

	if ( ! content || typeof window.jQuery !== 'function' ) {
		// LD's event is a jQuery trigger, so jQuery is a hard prerequisite.
		// Without it the region stays hidden — see the failure-mode note above.
		return;
	}

	// Question index -> the rows to reveal for it. A Map keyed by index (rather
	// than re-scanning every row per event) so a long quiz stays O(1) per event.
	//
	// `data-bnrmp-review-q` is a COMMA-SEPARATED list, not a single index: rows are
	// de-duplicated by URL server-side, so one topic recommended by several failed
	// questions is one row carrying all of their indices. That also means the same
	// row can be reached from more than one index, which is why reveal is
	// idempotent below (`if ( row.hidden )`).
	const byIndex = new Map();

	region.querySelectorAll( '[data-bnrmp-review-q]' ).forEach( ( row ) => {
		( row.getAttribute( 'data-bnrmp-review-q' ) || '' ).split( ',' ).forEach( ( raw ) => {
			const index = Number.parseInt( raw, 10 );

			if ( Number.isNaN( index ) ) {
				return;
			}

			if ( ! byIndex.has( index ) ) {
				byIndex.set( index, [] );
			}

			byIndex.get( index ).push( row );
		});
	});

	if ( ! byIndex.size ) {
		return;
	}

	let revealed = 0;

	window.jQuery( content ).on( 'questionSolvedIncorrect', ( event ) => {
		const index = event && event.values ? Number( event.values.index ) : NaN;
		const rows = byIndex.get( index );

		if ( ! rows ) {
			// The learner failed a question with no authored remediation
			// feedback. Correct behaviour: recommend nothing for it.
			return;
		}

		rows.forEach( ( row ) => {
			if ( row.hidden ) {
				row.hidden = false;
				revealed += 1;
			}
		});

		// Reveal the heading only once a row exists under it, so a learner who
		// failed only un-authored questions never sees an empty
		// "Recommended Review".
		if ( revealed > 0 ) {
			region.hidden = false;
		}
	});
}
